import { render, staticRenderFns } from "./LogoBox.vue?vue&type=template&id=7ffa6dc6&scoped=true&"
import script from "./LogoBox.vue?vue&type=script&lang=ts&"
export * from "./LogoBox.vue?vue&type=script&lang=ts&"
import style0 from "./LogoBox.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LogoBox.vue?vue&type=style&index=1&id=7ffa6dc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffa6dc6",
  null
  
)

export default component.exports